/**
 * Option lists for the Orbit-backed search filters on booking search, session search and session
 * overview. Each screen shows them only behind its filters.* switch; see
 * Plans/search-filters-behind-switches.md. A null value means "All" (no filter).
 */

/** Orbit OPC DeliveryMode — the same closed set session search's Delivery dropdown and pill use. */
export const DELIVERY_MODE_OPTIONS = [
  { value: 'Online', label: 'Online' },
  { value: 'In person', label: 'In person' }
];

/** Orbit provision type code: Alternative Provision or Specialist Provision. */
export const ORDER_TYPE_OPTIONS = [
  { value: 'AP', label: 'AP' },
  { value: 'SP', label: 'SP' }
];

/**
 * Session report status. "New" is a session whose report has not been started; "Cancelled" is a slot Orbit
 * cancelled with no settled report. The API matches these by NAME (NewBookingsService.ApplyReportStatus),
 * not by tblStatus id — see SESSION_REPORT_STATUSES for the numeric filter the client reports use.
 */
export const REPORT_STATUS_OPTIONS = [
  { value: 'New', label: 'New / Not started' },
  { value: 'Saved', label: 'Saved' },
  { value: 'Submitted', label: 'Submitted' },
  { value: 'Approved', label: 'Approved' },
  { value: 'Rejected', label: 'Rejected' },
  { value: 'Cancelled', label: 'Cancelled' }
];

/** Session attendance outcome. */
export const ATTENDANCE_OUTCOME_OPTIONS = [
  { value: 'Present', label: 'Present' },
  { value: 'Absent', label: 'Absent' },
  { value: 'Cancelled', label: 'Cancelled' }
];
